import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { AnimatePresence } from "framer-motion";
import ToastContext from "../../context/ToastContext";
import Toast from "./Toast";

const ToastContainer = () => {
  const context = useContext(ToastContext);
  const [portalTarget, setPortalTarget] = useState(null);

  // Create or get the portal target element
  useEffect(() => {
    let target = document.getElementById("toast-portal");

    if (!target) {
      target = document.createElement("div");
      target.id = "toast-portal";
      document.body.appendChild(target);
    }

    setPortalTarget(target);

    // Cleanup on unmount
    return () => {
      // Only remove if it's empty
      if (target && target.childNodes.length === 0 && target.parentNode) {
        target.parentNode.removeChild(target);
      }
    };
  }, []);

  // If context is not available or portal target not ready, don't render
  if (!context || !portalTarget) {
    return null;
  }

  const { toasts, removeToast } = context;

  // Handle toast dismissal
  const handleDismiss = (id) => {
    removeToast(id);
  };

  // Render the toast container in a portal
  return ReactDOM.createPortal(
    <div
      className="
        fixed
        top-5
        left-1/2
        -translate-x-1/2
        z-[9999]
        flex
        flex-col
        gap-3
        pointer-events-none
        w-full
        max-w-[500px]
        px-4
        sm:px-0
      "
    >
      <AnimatePresence mode="sync">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            id={toast.id}
            type={toast.type}
            message={toast.message}
            duration={toast.duration}
            dismissible={toast.dismissible}
            onDismiss={handleDismiss}
          />
        ))}
      </AnimatePresence>
    </div>,
    portalTarget
  );
};

export default ToastContainer;
